module.exports = __webpack_public_path__ + "img/inverted-bravado-logo.43f685f.svg";